import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=8381084c&"
import script from "./BlogArticle.vue?vue&type=script&lang=js&"
export * from "./BlogArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports